import { AxiosError } from 'axios';

import { GenericObject } from 'lynkco-up-core/dist/types/types';

import { carSharingClient } from '../shared';
import { serviceConfig } from '../../config';
import { VerificationType } from '../../types';

const endpointUrl = '/applicant/reset-check';

async function resetDriversLicense(
  caseId: string,
  customerNumber: string,
  verificationType?: VerificationType,
): Promise<GenericObject> {
  const url = `${serviceConfig.endpoints.onfido.root}${endpointUrl}`;

  try {
    const response = await carSharingClient.post(
      url,
      {
        caseId,
      },
      {
        headers: {
          'X-CustomerNumber': customerNumber,
          ...(verificationType ? { 'X-Verification-Type': verificationType } : {}),
        },
      },
    );

    return response.data;
  } catch (err) {
    if (err instanceof AxiosError && err.response) {
      throw new Error(err.response?.data.message);
    }
  }

  throw new Error('Failed to manually reset drivers license');
}

export default resetDriversLicense;
